import { render, staticRenderFns } from "./lat_ser_timeline.vue?vue&type=template&id=35f1f3bb&scoped=true&"
import script from "./lat_ser_timeline.vue?vue&type=script&lang=js&"
export * from "./lat_ser_timeline.vue?vue&type=script&lang=js&"
import style0 from "./lat_ser_timeline.vue?vue&type=style&index=0&id=35f1f3bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f1f3bb",
  null
  
)

export default component.exports